<div class="modal-container d-flex flex-column h-100">
    <div class="modal-header border-0 justify-content-start">
        <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
    </div>
    <div class="modal-body flex-grow-1 overflow-y-auto overflow-x-hidden">
      <ng-container *ngIf="!visibility">
        <app-inventory-detail 
          [formModel]="formModel"
          [data]="data">
        </app-inventory-detail>
      </ng-container>
      <ng-container *ngIf="visibility">
        <app-line-information
          [data]="data"
          [formModel]="formModel">
        </app-line-information>
      </ng-container>
    </div>
    <div class="modal-footer border-0 justify-content-end">
        <div class="m-0 d-flex gap-3 gap-sm-3">
            <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-danger  popup-button'"
                class="" (click)="cancel();clearValue()"
                [buttonLable]="enumButtonName.CANCEL"></app-button>
                <ng-container *ngIf="!visibility">
                    <app-button  [buttonType]="'button'" [button_2]="true"
                    [buttonClass]="false ? 'button-primary button  popup-button' : 'button-info button  popup-button'"
                    class="" [buttonLable]="'Next'"
                    (click)="onNextClick('Next')"></app-button>
                    </ng-container>
                <ng-container *ngIf="visibility">
                    <app-button  [buttonType]="'button'" [button_2]="true"
                    [buttonClass]="false ? 'button-primary button  popup-button' : 'button-info button  popup-button'"
                    class="" [buttonLable]="'Back'"
                    (click)="onNextClick('Back')"></app-button>
                    <app-button  [buttonType]="'button'" [button_2]="true"
                    [buttonClass]="true ? 'button-primary button  popup-button' : 'button-info button  popup-button'"
                    class="" [buttonLable]="'Add Inventory'"
                    (click)="onAddInventoryClick();clearValue()"></app-button>
                </ng-container>
        </div>
    </div>
</div>